// Runs the board reload after a socket reconnect, but only once the tab is
// visible and the browser is online, and only once per burst of reconnects.
//
// Reconnects mostly happen as a laptop wakes up. Reloading straight away sends
// the requests over a network that isn't back yet, or over a connection that
// died during sleep, and they hang for seconds before the browser gives up on
// it (DORA-305). A socket that flaps a few times in a row would also reload
// the whole board each time.
export const RESYNC_DEBOUNCE_MS = 2000;

export const createReconnectResync = (resync: () => void) => {
  let timer: ReturnType<typeof setTimeout> | null = null;

  const removeListeners = () => {
    document.removeEventListener("visibilitychange", schedule);
    window.removeEventListener("online", schedule);
  };

  const run = () => {
    timer = null;
    if (document.hidden) {
      document.addEventListener("visibilitychange", schedule);
    } else if (!navigator.onLine) {
      window.addEventListener("online", schedule);
    } else {
      resync();
    }
  };

  // Also the listener for becoming visible/online, so that waits out the
  // debounce again: the network usually needs a moment after the tab wakes.
  function schedule() {
    removeListeners();
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(run, RESYNC_DEBOUNCE_MS);
  }

  const cancel = () => {
    removeListeners();
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  return { schedule, cancel };
};
